import { createGlobalStyle } from "styled-components";
import * as Variables from "./Variables";

const GlobalStyle = createGlobalStyle`

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    -webkit-tap-highlight-color: transparent;
  }

  body{
    font-family: ${Variables.setFont.body};
    box-sizing: border-box;
    background: ${Variables.getColor().background};
    color: ${Variables.getColor().textColor};
    width: 100%;
    margin: 0 auto;
  }

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
  border-right: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-right: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: white;
}

  p::selection,
strong::selection,
h1::selection,
h2::selection,
h3::selection,
h4::selection,
h5::selection,
h6::selection  {
    background-color:${Variables.getColor().textColor};
    color: ${Variables.getColor().textColor};
}

  html {
    font-size: 10px;
    min-height: -webkit-fill-available;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
}


  h1, h2, h3, h4, h5, h6{
  font-family: ${Variables.setFont.body};
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  color: ${Variables.getColor().textColor};
  }

  h1 {
    font-size: 33px;
}
h2 {
    font-size: 30px;
}
h3 {
    font-size: 20px;
}

h4{
   font-size: 16px;
}

p {
    font-size: 1.4rem;
    line-height: 150%;
    font-family: ${Variables.setFont.body};
    font-weight: 400;
}


  a{
    text-decoration: none;
    font-family: ${Variables.setFont.body};
  }

  button, input{
    border: none;
    font-family: ${Variables.setFont.body};
    cursor: pointer;
    outline: none;
  }

`;


export default GlobalStyle;
